const initialState = {
  resultsList: [],
};

export const resultsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "results")
    return action.execute(state);
  return state;
};
